<ng-container *ngIf="mr">
  <a
    *ngIf="clickable; else staticIcon"
    class="mr-icon"
    [attr.data-state]="tone"
    [href]="mr.webUrl"
    target="_blank"
    rel="noopener noreferrer"
    [title]="tooltip"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()">
    <mat-icon svgIcon="mat:account_tree"></mat-icon>
  </a>
  <ng-template #staticIcon>
    <span class="mr-icon" [attr.data-state]="tone" [title]="tooltip">
      <mat-icon svgIcon="mat:account_tree"></mat-icon>
    </span>
  </ng-template>
</ng-container>
